export default __webpack_public_path__ + "static/media/Red-Cross-Circle.abcce0ce.svg";